/**
 * @generated SignedSource<<69d5ed3ca5e85361566a4f829bfd3fd0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Appropriateness = "APPROPRIATE" | "NOT_APPROPRIATE" | "NOT_EXPERIENCED" | "UNKNOWN";
export type CompliancePolicy = "SHARIA" | "STANDARD";
export type ComplianceStatus = "COMPLETED" | "FAILED" | "PENDING";
export type PepStatus = "FAILED" | "NONE" | "SUCCESS";
export type TaxEligibilityStatus = "CONFIRMED" | "UNCONFIRMED";
export type TradingReasonCode = "TRADING_ACTIVE" | "TRADING_DISABLED" | "USER_AA_NOT_COMPLETED" | "USER_CLIENT_CATEGORIZATION_PENDING" | "USER_COOL_OFF_ACTIVE" | "USER_DEACTIVATED" | "USER_NOT_APPROPRIATE" | "USER_NOT_TAX_COMPLIANT" | "USER_NOT_VERIFIED" | "USER_PEP_CHECK_FAILED" | "USER_PEP_CHECK_NOT_EXECUTED" | "USER_POST_COOLOFF_CONFIRMATION_PENDING" | "USER_PRETRADE_STATUS_INVALID" | "USER_TERMS_NOT_ACCEPTED" | "USER_WAITING_PERIOD_ACTIVE";
export type TwoFactorAuthenticationState = "DISABLED" | "ENABLED" | "RESET_IN_PROGRESS" | "SETUP_IN_PROGRESS";
export type UserLanguage = "AR" | "DE" | "EN" | "ES" | "FR" | "IT" | "PL" | "TR";
export type UserRole = "EXECUTION" | "READ_ONLY";
export type UserFullInfoQuery$variables = Record<PropertyKey, never>;
export type UserFullInfoQuery$data = {
  readonly me: {
    readonly __typename: string;
    readonly accountLevel?: {
      readonly __typename: "AccountLevel";
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly active?: boolean;
    readonly appropriateness?: Appropriateness | null | undefined;
    readonly appropriatenessRequiresTestCompletion?: boolean | null | undefined;
    readonly appropriatenessRequiresTestResubmission?: boolean | null | undefined;
    readonly approved?: boolean;
    readonly blacklisted?: boolean;
    readonly compliance?: {
      readonly appropriateness: ComplianceStatus;
      readonly coolOffTimeEnd: TimeScalar | null | undefined;
      readonly failuresCount: number | null | undefined;
      readonly waitTimeEnd: TimeScalar | null | undefined;
    } | null | undefined;
    readonly compliancePolicy?: CompliancePolicy | null | undefined;
    readonly cookiePreferences: {
      readonly functional: boolean;
      readonly marketing: boolean;
      readonly performance: boolean;
    };
    readonly fiat: {
      readonly name: string | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly hasTermsNotAccepted: boolean;
    readonly id: string;
    readonly language: UserLanguage;
    readonly notifications: {
      readonly unreadCount: number;
    };
    readonly onboarded: boolean;
    readonly pepStatus?: PepStatus;
    readonly providerActivated?: boolean;
    readonly role?: UserRole;
    readonly taxCompliant?: boolean | null | undefined;
    readonly taxEligibilityStatus?: TaxEligibilityStatus | null | undefined;
    readonly trading?: {
      readonly active: boolean | null | undefined;
      readonly reasonCode: TradingReasonCode | null | undefined;
    } | null | undefined;
    readonly tradingActive: boolean;
    readonly tradingDisabledReason?: string | null | undefined;
    readonly twoFactorAuthentication: TwoFactorAuthenticationState;
    readonly verificationReason?: string | null | undefined;
    readonly verificationStatus?: string;
    readonly verified?: boolean;
    readonly withdrawalsActive: boolean;
  } | null | undefined;
};
export type UserFullInfoQuery = {
  response: UserFullInfoQuery$data;
  variables: UserFullInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboarded",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tradingActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasTermsNotAccepted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "withdrawalsActive",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twoFactorAuthentication",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotifications",
  "kind": "LinkedField",
  "name": "notifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "CookiePreferences",
  "kind": "LinkedField",
  "name": "cookiePreferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "functional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "performance",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    }
  ],
  "type": "BusinessUser",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appropriateness",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pepStatus",
      "storageKey": null
    },
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestResubmission",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountLevel",
      "kind": "LinkedField",
      "name": "accountLevel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v10/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blacklisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingDisabledReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxEligibilityStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxCompliant",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Compliance",
      "kind": "LinkedField",
      "name": "compliance",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coolOffTimeEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "waitTimeEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "failuresCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compliancePolicy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Trading",
      "kind": "LinkedField",
      "name": "trading",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reasonCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IndividualUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFullInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Fiat",
            "kind": "LinkedField",
            "name": "fiat",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserFullInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Fiat",
            "kind": "LinkedField",
            "name": "fiat",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1e7bca46ce4e10171ad05e680c7b408",
    "id": null,
    "metadata": {},
    "name": "UserFullInfoQuery",
    "operationKind": "query",
    "text": "query UserFullInfoQuery {\n  me {\n    id\n    onboarded\n    language\n    tradingActive\n    hasTermsNotAccepted\n    __typename\n    withdrawalsActive\n    twoFactorAuthentication\n    notifications {\n      unreadCount\n    }\n    cookiePreferences {\n      marketing\n      functional\n      performance\n    }\n    fiat {\n      name\n      symbol\n      id\n    }\n    ... on BusinessUser {\n      role\n      approved\n    }\n    ... on IndividualUser {\n      pepStatus\n      appropriateness\n      appropriatenessRequiresTestCompletion\n      appropriatenessRequiresTestResubmission\n      active\n      accountLevel {\n        id\n        name\n        __typename\n      }\n      blacklisted\n      verified\n      tradingDisabledReason\n      verificationStatus\n      verificationReason\n      onboarded\n      language\n      providerActivated\n      taxEligibilityStatus\n      taxCompliant\n      compliance {\n        appropriateness\n        coolOffTimeEnd\n        waitTimeEnd\n        failuresCount\n      }\n      compliancePolicy\n      trading {\n        active\n        reasonCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4c4ba540037b577ef318f81a22138fc";

export default node;
